export const ListItems = [
  'Improve per-store OSA by over 5% and increase in-store brand visibility',
  'Ensure 100% store compliance and optimize trade payouts',
  'Analyze competition and get tailor-fit per-store recommendations',
  'Lift per-store sales by upto 5% with real-time and in-context action plans'
];
export const LoginHeader =
  'Retail Execution Insights - Actionable, Real-time and Available at your fingertips!';
